import { useState } from 'react';
import { Button, Input } from 'components/ui';
import { isValidOtp } from 'lib/validators';

/** Step 2 of login — enter the OTP that was sent to the phone. */
export function OtpStep({
  phone,
  onSubmit,
  onResend,
  onBack,
  isSubmitting,
  isResending,
  error,
  devOtp,
}) {
  const [otp, setOtp] = useState('');
  const [touched, setTouched] = useState(false);
  const valid = isValidOtp(otp);

  const handleSubmit = (event) => {
    event.preventDefault();
    setTouched(true);
    if (valid) onSubmit(otp);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
      <p className="text-sm text-slate-500">
        Enter the code we sent to <span className="font-medium text-slate-700">+91 {phone}</span>.
      </p>

      <Input
        label="One-time password"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        placeholder="••••••"
        value={otp}
        onChange={(event) => setOtp(event.target.value)}
        onBlur={() => setTouched(true)}
        error={touched && !valid ? 'Enter the OTP you received.' : undefined}
        autoFocus
      />

      {devOtp && (
        <p className="rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-700 ring-1 ring-inset ring-amber-200">
          Development OTP: <span className="font-semibold">{devOtp}</span>
        </p>
      )}

      {error && <p className="text-sm text-red-600">{error}</p>}

      <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} disabled={!valid}>
        Verify &amp; continue
      </Button>

      <div className="flex items-center justify-between text-sm">
        <button
          type="button"
          onClick={onBack}
          className="font-medium text-slate-500 transition hover:text-slate-700"
        >
          Change number
        </button>
        <button
          type="button"
          onClick={onResend}
          disabled={isResending}
          className="font-medium text-brand-700 transition hover:text-brand-800 disabled:opacity-60"
        >
          {isResending ? 'Resending…' : 'Resend OTP'}
        </button>
      </div>
    </form>
  );
}

export default OtpStep;
